import { render, staticRenderFns } from "./PublicationsSection.vue?vue&type=template&id=09c58f6e&"
import script from "./PublicationsSection.vue?vue&type=script&lang=js&"
export * from "./PublicationsSection.vue?vue&type=script&lang=js&"
import style0 from "./PublicationsSection.vue?vue&type=style&index=0&id=09c58f6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports